/* global SideDrawer, debounce, initLazyImages */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');

      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll('.js-drawer-sort-by');
        this.desktopSortBy = document.querySelector('.products-toolbar__sort');
        // Ordinamento attivo al caricamento. Serve come riferimento in
        // isFormStateDirty(): l'URL spesso non porta sort_by (si sta usando il
        // default della collection), quindi senza questo valore il confronto
        // con il form risulterebbe sempre diverso e la CTA Applica comparirebbe
        // gia' all'apertura del drawer, senza che l'utente abbia scelto nulla.
        const sortIniziale = [...this.mobileSortByOptions].find((o) => o.checked);
        this.defaultSortBy = sortIniziale
          ? sortIniziale.value
          : (this.desktopSortBy && this.desktopSortBy.value) || '';
      }

      this.handleBreakpointChange();
      this.addListeners();

      // Richiesta Cisalfa (23/09): all'atterraggio in pagina il pannello
      // filtri parte sempre chiuso, su desktop e su mobile. Non si ripristina
      // piu' l'apertura della sessione precedente (`f-open`, bug Unguess
      // 451158/451662): il pannello si apre solo col tap su "Filtra" e, dato
      // che i filtri si applicano via fetch, resta aperto finche' si filtra.



    


    }

    addListeners() {
      if (this.filteringEnabled) {
        this.breakpointChangeHandler = this.breakpointChangeHandler
          || this.handleBreakpointChange.bind(this);
        this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);

        // CTA "Cerca" - applica i filtri al click
        this.applyBtn = this.querySelector('.js-apply-filters');
        this.applyBtnContainer = this.querySelector('.facets__apply');
        if (this.applyBtn) {
          this.applyBtn.addEventListener('click', this.handleApplyFiltersBtn.bind(this));
        }

        // Listen for checkbox changes to show/hide apply button
        this.filters.addEventListener('change', this.handleFilterCheckboxChange.bind(this));

        /* IB-656 fix "Selezionando solo prezzo da mobile non compare CTA":
           change event sui range input puo' non sparare in modo affidabile su
           mobile (drag senza rilascio "pulito" su Safari iOS, o lo slider
           setta value senza change formale). Ascolto anche 'input' SOLO per
           i filtri price_range cosi' il bottone Applica appare appena
           l'utente tocca lo slider. */
        this.filters.addEventListener('input', (evt) => {
          if (!evt.target || evt.target.tagName !== 'INPUT') return;
          if (!evt.target.closest('.filter[data-type="price_range"]')) return;
          this.updateApplyButtonVisibility();
        });
      }

      if (this.sortingEnabled) {
        this.desktopSortBy.addEventListener('change', this.handleFilterChange.bind(this));
      }

      /* IB-656: mutua esclusione filtri <-> hamburger su mobile.
         Filtri e menu hamburger non possono restare entrambi aperti.
         - Apertura hamburger -> chiudo filtri se aperti.
         - Apertura filtri    -> chiudo hamburger se aperto. */
      this.setupMutualExclusionMobile();

      // Add listener for mobile apply filters button
      const applyFiltersBtn = this.querySelector('.js-close-drawer-mob');
      if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', this.handleApplyFiltersClick.bind(this));
      }

      // Add listener for mobile close filters button
      const closeFiltersBtn = this.querySelector('.js-close-filters-mobile');
      if (closeFiltersBtn) {
        closeFiltersBtn.addEventListener('click', this.handleCloseFiltersMobile.bind(this));
      }

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    /**
     * Commit mobile ("Show X results"): committa i filtri + chiude drawer.
     */
    handleApplyFiltersClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      this.preserveSortBy(searchParams);
      for (const [key, value] of searchParams) {
        if (value === '') emptyParams.push(key);
      }
      emptyParams.forEach((p) => searchParams.delete(p));

      if (this.liveFilterAbortController) this.liveFilterAbortController.abort();
      this.applyFilters(searchParams.toString(), evt, true, null, 'commit').then(() => {
        if (!theme.mediaMatches.lg) this.close();
      });
    }

    /**
     * Handles viewport breakpoint changes.
     */
    handleBreakpointChange() {
      if (theme.mediaMatches.lg) {
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
        // Remove mobile class on desktop
        document.body.classList.remove('active-filter-mobile');

      } else {
        this.close();
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-hidden', 'true');
        this.hidden = false;
      }
    }

    /**
     * Opens the drawer and adds body class on mobile.
     */
    open() {
      super.open();
      if (!theme.mediaMatches.lg) {
        document.body.classList.add('active-filter-mobile');
      }
    }

    /**
     * Allinea il toggle dei filtri allo stato reale del pannello.
     *
     * IB-656 (feedback Sara, 18/08): products-toolbar.toggleFilters() decide se
     * aprire o chiudere leggendo `is-active` sul .js-toggle-filters. Quando il
     * pannello viene chiuso da fuori (mutua esclusione con l'hamburger, cambio
     * di breakpoint, commit dei filtri) quella classe restava impostata: al tap
     * successivo il toggle la rimuoveva "a vuoto" senza che nulla si aprisse, e
     * serviva un secondo tap. Sincronizzando qui, un tap torna sufficiente.
     */
    syncToggleState(aperto) {
      const toggle = document.querySelector('.js-toggle-filters');
      if (toggle) {
        toggle.classList.toggle('is-active', aperto);
        toggle.setAttribute('aria-expanded', String(aperto));
      }
      const toolbar = document.querySelector('products-toolbar');
      if (toolbar) toolbar.filtersOpen = aperto;
    }

    /**
     * Closes the drawer and removes body class.
     */
    close() {
      super.close();
      document.body.classList.remove('active-filter-mobile');
      if (!theme.mediaMatches.lg) {
        this.syncToggleState(false);
        this.discardPendingSelection();
      }
    }

    /**
     * IB-656 (check Eliana 27/08, verifica pre-prod 14/09). Chiudendo il
     * pannello mobile senza Applica - hamburger, "Chiudi filtri", FILTRA - la
     * selezione restava nel form: riaprendo si trovavano spunte, chip e
     * "N filtri applicati" su una griglia non filtrata. In chiusura il form
     * torna allo stato committato nell'URL. Dopo un commit il form e' gia'
     * allineato, quindi non c'e' nulla da scartare e non parte nessuna fetch.
     */
    discardPendingSelection() {
      if (!this.form || !this.isFormStateDirty()) return;

      const urlParams = new URLSearchParams(window.location.search);
      FacetFilters.syncCheckboxesToParams(this.form, urlParams);

      const urlSort = urlParams.get('sort_by') || this.defaultSortBy || '';
      this.form.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
        radio.checked = radio.value === urlSort;
      });

      if (this.liveFilterDebounce) clearTimeout(this.liveFilterDebounce);
      this.updateApplyButtonVisibility();
      // Rigenera conteggi, chip e titolo "filtri applicati" sullo stato reale.
      this.applyFiltersLive();
    }

    /**
     * Opens filters on mobile (inline panel, not drawer).
     */
    openMobile() {
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('active-filter-mobile');
      this.syncToggleState(true);
    }

    /**
     * Closes filters on mobile (inline panel, not drawer).
     */
    closeMobile() {
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('active-filter-mobile');
      this.syncToggleState(false);
      this.discardPendingSelection();
    }

    /**
     * Handles click on the mobile close filters button.
     */
    handleCloseFiltersMobile() {
      // Trigger the filter toggle button to close filters
      const filterToggle = document.querySelector('.js-toggle-filters');
      if (filterToggle) {
        filterToggle.click();
      }
    }

    /**
     * Handles checkbox change: live filter.
     *
     * Quando l'utente clicca un checkbox filtro, fa la fetch (debounced) della
     * collection con i filtri aggiornati. Il response ha:
     * - il filter markup con i nuovi value.count e l'attributo disabled sui
     *   valori con count == 0 (vedi facet-filters.liquid:266)
     * - il results grid filtrato (sostituito in DOM da applyFilters)
     * - i counter aggiornati per i bottoni apply
     *
     * Cosi' l'utente vede contestualmente: counts aggiornati, opzioni
     * incompatibili disabilitate, results live.
     */
    handleFilterCheckboxChange(evt) {
      if (!evt || !evt.target) return;
      if (!evt.target.closest('.facets__filters')) return;
      if (evt.target.tagName !== 'INPUT') return;
      // I radio del sort vivono in '.facets__filters' su mobile. Un handler
      // dedicato esiste solo per il sort desktop: qui va almeno aggiornata la
      // visibilita' della CTA, altrimenti la scelta non e' confermabile. Non si
      // passa dal live filter: su mobile l'ordinamento si applica al commit.
      if (evt.target.name === 'sort_by') {
        this.updateApplyButtonVisibility();
        return;
      }
      // Accetta checkbox dei filtri normali + slider/number inputs del price_range
      // (cosi' il bottone Applica appare anche modificando solo il prezzo - bug IB-656).

      this.updateApplyButtonVisibility();

      // Debounce: piu' largo per price (l'utente trascina o digita).
      const isPriceRange = !!evt.target.closest('.filter[data-type="price_range"]');
      const debounceMs = isPriceRange ? 500 : 250;
      if (this.liveFilterDebounce) clearTimeout(this.liveFilterDebounce);
      this.liveFilterDebounce = setTimeout(() => this.applyFiltersLive(evt), debounceMs);
    }

    /**
     * Bottone Applica visibile quando lo stato del form differisce da quello
     * committato in URL (form "dirty"). Cosi':
     * - All'apertura della pagina: form match URL -> bottone nascosto
     * - Check/uncheck checkbox -> form differs -> bottone visibile (anche
     *   nel caso edge "URL ha filtri, utente li toglie tutti": il form
     *   diventa vuoto mentre l'URL ne ha ancora -> dirty -> bottone visibile,
     *   permette il commit a "nessun filtro").
     * - Post-commit: applyResultsGrid aggiorna URL -> stati riallineati ->
     *   chiamare di nuovo questo metodo nasconde il bottone.
     */
    updateApplyButtonVisibility() {
      const dirty = this.isFormStateDirty();
      const hasAnyFilterSelected = this.hasAnyFilterValue();

      if (this.applyBtnContainer) {
        this.applyBtnContainer.toggleAttribute('hidden', !dirty);
      }
      /* IB-656 (Matteo, 10/06): la CTA "Applica" su mobile deve comparire SOLO
         quando ci sono modifiche non ancora applicate (form dirty vs URL).
         Dopo l'applicazione il form torna allineato all'URL -> non dirty ->
         "Applica" nascosta, resta visibile solo "Chiudi i filtri" (sibling
         sempre presente nel footer). Ricompare solo a nuove modifiche.
         .facets__footer wrappa esclusivamente il bottone Applica. */
      const mobileApplyContainer = this.querySelector('.drawer__footer .facets__footer');
      if (mobileApplyContainer) {
        mobileApplyContainer.toggleAttribute('hidden', !dirty);
      }

      /* IB-656 fix latenza Azzera filtri: stesso ragionamento dell'Applica.
         Senza questo i pulsanti "Azzera filtri" / "Azzera tutto" / la
         sezione .facets__active-filters venivano aggiornati solo da
         updateActiveFilters() dopo la fetch (~700ms-1s su mobile Chrome).
         Adesso togglano sincronicamente in base allo stato del form. */
      if (this.activeFilters) {
        this.activeFilters.hidden = !hasAnyFilterSelected;
      }
      const clearAllMobile = this.querySelector('.js-clear-all-mobile');
      if (clearAllMobile) {
        clearAllMobile.classList.toggle('is-hidden', !hasAnyFilterSelected);
      }
      const clearAllBottom = this.querySelector('.facets__clear-all-bottom');
      if (clearAllBottom) {
        clearAllBottom.style.display = hasAnyFilterSelected ? 'block' : 'none';
      }
    }

    /**
     * IB-656: mutua esclusione filtri <-> hamburger su mobile.
     * Si attacca a:
     *  - .main-menu__toggle (hamburger summary)
     *  - .js-toggle-filters (toggle filtri lato controls)
     * Su mobile (<1024px), quando uno dei due apre, l'altro viene chiuso.
     */
    setupMutualExclusionMobile() {
      const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

      const closeFilters = () => {
        if (typeof this.close === 'function' && this.hasAttribute('open')) {
          this.close();
        }
        if (typeof this.closeMobile === 'function') {
          this.closeMobile();
        }
        // Toggle dei filtri usa <details>: forzo lo state coerente.
        const filtersDetails = this.closest('details');
        if (filtersDetails && filtersDetails.open) filtersDetails.open = false;
        document.body.classList.remove('active-filter-mobile');
      };

      const closeHamburger = () => {
        const main = document.querySelector('.main-menu__disclosure');
        if (!main) return;
        if (main.classList.contains('is-open') || main.hasAttribute('open')) {
          // Click programmaticamente sul toggle per riusare il lifecycle nativo
          // (gestisce transition, aria-expanded, body class, ecc.).
          const toggle = main.querySelector('.main-menu__toggle');
          if (toggle) {
            toggle.click();
          } else {
            main.removeAttribute('open');
            main.classList.remove('is-open');
          }
        }
      };

      // Hamburger clicked -> chiudi filtri.
      document.addEventListener(
        'click',
        (evt) => {
          if (!isMobile()) return;
          const burger = evt.target.closest('.main-menu__toggle');
          if (!burger) return;
          // Apertura imminente solo se attualmente NON aperto.
          const main = burger.closest('.main-menu__disclosure');
          if (main && !main.classList.contains('is-open')) {
            closeFilters();
          }
        },
        true
      );

      // Filtri clicked -> chiudi hamburger.
      document.addEventListener(
        'click',
        (evt) => {
          if (!isMobile()) return;
          const filtersToggle = evt.target.closest(
            '.js-toggle-filters, [data-toggle="facets"], [aria-controls*="facet"]'
          );
          if (!filtersToggle) return;
          const filtersDetails = filtersToggle.closest('details');
          // Se il filter toggle sta per APRIRE (no [open]) -> chiudi hamburger.
          if (!filtersDetails || !filtersDetails.open) {
            closeHamburger();
          }
        },
        true
      );
    }

    /**
     * Controlla se il form ha almeno un filtro selezionato (oltre a sort_by).
     * Usato per mostrare/nascondere immediatamente i bottoni Azzera filtri
     * senza attendere la fetch dei facet aggiornati.
     */
    hasAnyFilterValue() {
      const formData = new FormData(this.form);
      for (const [key, value] of formData) {
        if (!key.startsWith('filter.')) continue;
        if (value !== '' && value != null) return true;
      }
      return false;
    }

    /**
     * Confronta i parametri filter.* del form con quelli dell'URL.
     * @returns {boolean} true se lo stato e' "dirty".
     */
    isFormStateDirty() {
      const formData = new FormData(this.form);
      const formParams = new URLSearchParams(formData);
      const urlParams = new URLSearchParams(window.location.search);
      const formFilters = FacetFilters.serializeFilterParams(formParams);
      const urlFilters = FacetFilters.serializeFilterParams(urlParams);
      if (formFilters !== urlFilters) return true;

      // IB-656: serializeFilterParams tiene solo le chiavi `filter.`, quindi il
      // solo cambio di ordinamento non risultava mai una modifica pendente. Nel
      // drawer mobile l'ordinamento si conferma con la CTA Applica, che pero'
      // resta nascosta finche' il form non e' dirty: scegliendo un ordinamento
      // senza toccare filtri la scelta non era confermabile.
      if (!this.sortingEnabled) return false;
      // Dal 29/08 l'ordinamento vive fuori dal drawer e il form non ha piu'
      // campi sort_by: il confronto dava sempre "dirty" con sort_by nell'URL
      // (Applica visibile senza modifiche, fetch a ogni chiusura del pannello).
      if (!this.form.querySelector('[name="sort_by"]')) return false;
      const formSort = formParams.get('sort_by') || '';
      const urlSort = urlParams.get('sort_by') || this.defaultSortBy || '';
      return formSort !== urlSort;
    }

    /**
     * Serializza solo i parametri filter.* (non-blank), sorted, per
     * confronto deterministico.
     * @param {URLSearchParams} params
     * @returns {string}
     */
    static serializeFilterParams(params) {
      const pairs = [];
      params.forEach((value, key) => {
        if (key.startsWith('filter.') && value) {
          pairs.push(`${key}=${value}`);
        }
      });
      return pairs.sort().join('&');
    }

    /**
     * Mantiene l'ordinamento attivo nei parametri costruiti dal form.
     *
     * Il controllo sort desktop e' un <custom-select> che vive fuori dal form
     * #facets e, non ricevendo `include_native`, non ha il <select> nativo che
     * lo aggancerebbe al form: `new FormData(this.form)` non contiene mai
     * `sort_by`. Il vecchio codice faceva
     *   const currentSortBy = searchParams.get('sort_by');
     *   if (currentSortBy) searchParams.set('sort_by', currentSortBy);
     * cioe' rileggeva e riscriveva un valore che era gia' assente: un no-op.
     * Risultato: ogni applicazione o rimozione di un filtro riscriveva l'URL
     * senza `sort_by` e l'ordinamento tornava a quello di default.
     *
     * Il valore viene quindi ripreso dalla query string corrente quando il form
     * non lo espone (su mobile i radio `sort_by` stanno dentro il form e hanno
     * la precedenza).
     * @param {URLSearchParams} searchParams - Parametri costruiti dal form.
     */
    preserveSortBy(searchParams) {
      if (!this.sortingEnabled) return;

      let sortBy = searchParams.get('sort_by');
      if (!sortBy) {
        sortBy = new URLSearchParams(window.location.search).get('sort_by');
      }
      if (sortBy) searchParams.set('sort_by', sortBy);
    }

    /**
     * Builds params from form + triggers preview applyFilters (filters-only).
     * NON aggiorna la grid: il commit avviene solo al click di Applica/Show X.
     * Aborta la fetch in volo se l'utente clicca un altro filtro nel mentre.
     */
    applyFiltersLive(evt) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      this.preserveSortBy(searchParams);
      searchParams.forEach((value, key) => { if (!value) emptyParams.push(key); });
      emptyParams.forEach((key) => searchParams.delete(key));

      if (this.liveFilterAbortController) this.liveFilterAbortController.abort();
      this.liveFilterAbortController = new AbortController();

      this.applyFilters(searchParams.toString(), evt, false, this.liveFilterAbortController.signal, 'preview');
    }

    /**
     * Commit dei filtri ("Cerca" desktop / "Show X" mobile).
     * Costruisce qs dal form + applyFilters mode='commit' (aggiorna grid + URL).
     */
    handleApplyFiltersBtn(evt) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      this.preserveSortBy(searchParams);
      searchParams.forEach((value, key) => { if (!value) emptyParams.push(key); });
      emptyParams.forEach((key) => searchParams.delete(key));

      if (this.liveFilterAbortController) this.liveFilterAbortController.abort();
      this.applyFilters(searchParams.toString(), evt, true, null, 'commit').then(() => {
        // IB-656: nel drawer mobile esistono due CTA di commit, .js-apply-filters
        // e .js-close-drawer-mob; solo la seconda chiudeva il drawer. Erano i due
        // "APPLICA" segnalati il 18/08 e, nel risolvere il doppio pulsante, e'
        // rimasta visibile proprio quella che non chiude: l'utente applicava e
        // restava sul pannello, senza vedere i risultati. Su desktop non si
        // chiude nulla, il pannello filtri e' una colonna della pagina.
        if (!theme.mediaMatches.lg) this.close();
      });
    }

    /**
     * Handles 'change' events on the sort by dropdown (desktop).
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      if (this.sortingEnabled) {
        // Stesso fallback di preserveSortBy: il form non espone `sort_by`, quindi
        // senza la query string corrente un evento privo di valore selezionato
        // azzererebbe l'ordinamento.
        let currentSortBy = searchParams.get('sort_by')
          || new URLSearchParams(window.location.search).get('sort_by');

        /* IB-656 (Matteo): "gli ordinamenti non funzionano". Il valore
           selezionato veniva letto SOLO da evt.detail.selectedValue, valido
           per <custom-select>. Se il controllo sort emette un change "nativo"
           (o evt.detail manca), il valore non veniva aggiornato e l'URL
           manteneva il sort precedente. Leggo il valore in modo robusto da
           entrambe le sorgenti. */
        let selectedSort = null;
        if (evt.target && evt.target.tagName === 'CUSTOM-SELECT' && evt.detail) {
          selectedSort = evt.detail.selectedValue;
        } else if (evt.target && typeof evt.target.value === 'string' && evt.target.value) {
          selectedSort = evt.target.value;
        }

        if (selectedSort) {
          currentSortBy = selectedSort;
          // Keep the mobile facets form sync'd with the desktop sort by dropdown
          this.mobileSortByOptions.forEach((option) => {
            option.checked = option.value === selectedSort;
          });
        }

        // Set the 'sort_by' parameter.
        if (currentSortBy) searchParams.set('sort_by', currentSortBy);
      }

      // Get empty parameters.
      searchParams.forEach((value, key) => {
        if (!value) emptyParams.push(key);
      });

      // Remove empty parameters.
      emptyParams.forEach((key) => {
        searchParams.delete(key);
      });

      this.applyFilters(searchParams.toString(), evt);
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter per-group 'clear': preview, no grid commit.
      // L'URL del link contiene i parametri senza il filtro corrente.
      // Sincronizziamo i checkbox del form a quello stato e facciamo preview.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        const newParams = new URL(evt.target.href).searchParams;
        FacetFilters.syncCheckboxesToParams(this.form, newParams);
        this.updateApplyButtonVisibility();
        this.applyFiltersLive(evt);
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        const isExpanded = target.classList.contains('is-expanded');
        const maxOptions = parseInt(this.dataset.maxOptions || 6, 10);

        if (isExpanded) {
          // Collapse: hide items beyond the limit
          filter.querySelectorAll('li').forEach((el, index) => {
            if (index >= maxOptions) {
              el.classList.add('js-hidden');
            }
          });
          target.textContent = target.dataset.more;
          target.classList.remove('is-expanded');
        } else {
          // Expand: show all items
          filter.querySelectorAll('li').forEach((el) => {
            el.classList.remove('js-hidden');
          });
          target.textContent = target.dataset.less;
          target.classList.add('is-expanded');
        }
      }
    }

    /**
     * Handles 'click' events on the active filters (chip remove).
     * Preview: aggiorna i filtri ma non la grid (commit solo su Applica).
     */
    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;
      evt.preventDefault();
      const newParams = new URL(evt.target.href).searchParams;
      FacetFilters.syncCheckboxesToParams(this.form, newParams);

      // Unguess 451609: "Azzera tutto" svuotava le spunte ma lasciava griglia e
      // URL filtrati fino al click su Applica, per un momento la pagina diceva
      // "nessun filtro" mostrando prodotti filtrati. Azzerare e' un'azione
      // conclusiva: si committa subito, come il pulsante "Azzera filtri" in fondo
      // al pannello. La rimozione del singolo chip resta in anteprima.
      if (evt.target.closest('.js-clear-all')) {
        this.preserveSortBy(newParams);
        if (this.liveFilterAbortController) this.liveFilterAbortController.abort();
        this.applyFilters(newParams.toString(), evt, true, null, 'commit').then(() => {
          this.updateApplyButtonVisibility();
        });
        return;
      }

      this.updateApplyButtonVisibility();
      this.applyFiltersLive(evt);
    }

    /**
     * Sincronizza i checkbox e gli input price-range del form ai params
     * target (es. da url_to_remove). Per i checkbox: checked = name/value
     * in params. Per i price input (gte/lte): se il name e' assente dai
     * params -> reset al min/max naturale + updateTrack (IB-656 C2.4.2
     * 'Azzera prezzi non aggiorna subito la barra').
     * @param {HTMLFormElement} form
     * @param {URLSearchParams} targetParams
     */
    static syncCheckboxesToParams(form, targetParams) {
      const allowed = new Set();
      const namesInTarget = new Set();
      targetParams.forEach((val, key) => {
        allowed.add(`${key}=${val}`);
        namesInTarget.add(key);
      });
      form.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
        const pair = `${cb.name}=${cb.value}`;
        cb.checked = allowed.has(pair);
      });
      // Reset price range inputs (number + slider) non presenti nei params.
      form.querySelectorAll('input[type="number"], input[type="range"]').forEach((inp) => {
        if (namesInTarget.has(inp.name)) return;
        if (inp.name && inp.name.endsWith('.gte')) {
          inp.value = inp.type === 'number' ? '' : (inp.min || '');
        } else if (inp.name && inp.name.endsWith('.lte')) {
          inp.value = inp.type === 'number' ? '' : (inp.max || '');
        }
      });
      // Gli slider del price-range non hanno name (non vanno nella query):
      // il ciclo sopra non li tocca, quindi la barra restava sui vecchi valori
      // fino alla risposta del server. Si riallineano ai number input.
      form.querySelectorAll('price-range').forEach((pr) => {
        const { minNumberInput, maxNumberInput, minSliderInput, maxSliderInput } = pr;
        if (minNumberInput && minSliderInput && !namesInTarget.has(minNumberInput.name)) {
          minSliderInput.value = minSliderInput.min;
        }
        if (maxNumberInput && maxSliderInput && !namesInTarget.has(maxNumberInput.name)) {
          maxSliderInput.value = maxSliderInput.max;
        }
        if (typeof pr.updateTrack === 'function') pr.updateTrack();
      });
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      // IB - bug 451528: la voce di history creata dalla navigazione server
      // (primo ingresso in collection/search) ha `state === null`. Uscendo dal
      // vecchio `if (evt.state !== null)` il back verso quella voce non veniva
      // gestito: l'URL tornava senza filtri ma griglia e form restavano sullo
      // stato filtrato, dando l'impressione che il back "perdesse solo alcuni"
      // filtri. Ora si usa sempre la query string di destinazione come fonte
      // di verita', con lo state di pushState come scorciatoia quando c'e'.
      let searchParams = '';

      if (evt.state && evt.state.searchParams) {
        ({ searchParams } = evt.state);
      } else {
        searchParams = window.location.search.replace(/^\?/, '');
      }

      this.applyFilters(searchParams, null, false);
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     * @param {AbortSignal} [signal=null] - Aborta la fetch (live filter mode).
     * @param {'commit'|'preview'} [mode='commit'] - 'preview' aggiorna solo
     *   filtri + bottoni count; 'commit' aggiorna anche grid + URL.
     */
    async applyFilters(searchParams, evt, updateUrl = true, signal = null, mode = 'commit') {
      const customPagination = document.querySelector('custom-pagination');
      if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

      // Loader sui prodotti solo in mode='commit': la griglia cambia
      // davvero. In 'preview' i prodotti non si toccano fino al click di
      // Applica, mostrare loading sarebbe fuorviante (l'utente pensa che
      // i prodotti si stiano caricando quando in realta' restano gli stessi).
      if (mode === 'commit') this.results.classList.add('is-loading');

      // Disable "Show X results" button until submission is complete.
      const closeBtn = this.querySelector('.js-close-drawer-mob');
      closeBtn.ariaDisabled = 'true';
      closeBtn.classList.add('is-loading');

      // Fetch filtered products markup.
      let response;
      try {
        response = await fetch(`${window.location.pathname}?${searchParams}`, signal ? { signal } : undefined);
      } catch (err) {
        if (err.name === 'AbortError') {
          // Live filter mode: nuova fetch ha rimpiazzato questa
          return;
        }
        throw err;
      }

      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        // Update the filters.
        if (this.filteringEnabled) this.updateFilters(tmpl.content, evt);

        // Update the label of the mobile filter button (count live)
        closeBtn.innerText = tmpl.content.querySelector('.js-close-drawer-mob').innerText;

        // Sync count sul bottone Apply desktop ("Cerca") con il count live
        // letto da data-num-results emesso da main-collection-products.liquid.
        const newResultsCountEl = tmpl.content.querySelector('.collection-products-main');
        if (newResultsCountEl && this.applyBtn) {
          const newCount = newResultsCountEl.dataset.numResults;
          const countSpan = this.applyBtn.querySelector('.js-results-count');
          if (countSpan && newCount) countSpan.textContent = newCount;
        }

        // Deriva compatibilita' filtri dai product card nella response.
        // Per ogni valore di filtro (es. brand=Adidas) NON presente in
        // nessun product card della response, disabilita il checkbox:
        // significa che con i filtri correnti nessun prodotto match quel
        // valore. Funziona sia per filtri product-level (vendor, type)
        // sia variant-level (size, color via metafield).
        this.applyDerivedDisabledFromCards(tmpl.content);

        // commit-only: update results grid + URL + scroll
        if (mode === 'commit') {
          this.applyResultsGrid(tmpl.content, searchParams, updateUrl, customPagination);
          // Post-commit l'URL ora matcha il form -> niente stato dirty -> nascondi
          this.updateApplyButtonVisibility();
        }

        // Enable the "Show X results" button
        closeBtn.classList.remove('is-loading');
        closeBtn.removeAttribute('aria-disabled');

        // Renable infinite scroll
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'false';

        // Broadcast the update for anything else to hook into
        document.dispatchEvent(new CustomEvent('on:facet-filters:updated'), { bubbles: true });
      }

      // Rimuove is-loading anche per sicurezza (no-op se non era stato applicato in preview)
      this.results.classList.remove('is-loading');
    }

    /**
     * Mappa filter.param_name -> dataset key sui product card.
     * Estensibile: aggiungere voci per nuovi filtri se serve.
     */
    static get FILTER_PARAM_TO_CARD_DATASET() {
      return {
        'filter.p.vendor': 'vendor',
        'filter.p.product_type': 'productType',
        'filter.p.m.intersport.gender': 'gender',
        'filter.p.m.intersport.macrocategory': 'macrocategory',
        'filter.p.m.intersport.tag_keywords': 'tagKeywords',
        'filter.v.m.custom.color_macro': 'colors',
        'filter.v.m.custom.universal_size': 'sizes',
      };
    }

    /**
     * I valori dei filtri a zero risultati vengono nascosti server-side dal
     * template (facet-filters.liquid: `value.count > 0 or value.active`, con
     * la setting `show_filter_deadends = false`). E' l'approccio corretto:
     * usa i conteggi esatti di Shopify (non le sole card della prima pagina),
     * funziona su ogni entry-point (anche URL filtrato diretto) e preserva la
     * multiselezione OR. Qui in JS non disabilitiamo nulla — ci limitiamo a
     * ri-abilitare eventuali checkbox rimasti disabled da markup vecchio.
     */
    applyDerivedDisabledFromCards() {
      const mapping = FacetFilters.FILTER_PARAM_TO_CARD_DATASET;
      Object.keys(mapping).forEach((paramName) => {
        this.form
          .querySelectorAll(`input[type="checkbox"][name="${paramName}"]`)
          .forEach((cb) => {
            cb.disabled = false;
          });
      });
    }

    /**
     * IB-656 (24/09): la griglia arriva dal server con le classi "filtri
     * chiusi" (il pannello parte chiuso al caricamento). Se l'utente ha aperto
     * la colonna filtri su desktop, dopo Applica la griglia passava da 3 a 4
     * colonne con il pannello ancora aperto. Si riallinea allo stato attuale.
     */
    syncGridColumns() {
      if (!theme.mediaMatches.lg) return;
      const toolbar = document.querySelector('products-toolbar');
      const productsList = this.results.querySelector(':scope > .grid');
      if (!toolbar || !productsList) return;
      const classes = toolbar.filtersOpen
        ? productsList.dataset.filtersOpenClasses
        : productsList.dataset.filtersClosedClasses;
      if (classes) productsList.className = classes;
    }

    /**
     * Applica i risultati al DOM (mode=commit): swap grid, URL, scroll, reinit.
     * @param {DocumentFragment} content - tmpl.content della fetched page.
     * @param {string} searchParams - Query string per pushState.
     * @param {boolean} updateUrl - Aggiorna history.
     * @param {Element|null} customPagination - Custom pagination element.
     */
    applyResultsGrid(content, searchParams, updateUrl, customPagination) {
      const fetchedResults = content.getElementById('filter-results');
      if (fetchedResults) {
        // eslint-disable-next-line no-param-reassign
        this.results.innerHTML = fetchedResults.innerHTML;
        this.syncGridColumns();
      }

      // IB-656: il conteggio in testata ("(204 prodotti)") restava quello del
      // caricamento. La risposta e' la pagina intera, gia' calcolata sui
      // filtri applicati: si riprende il testo da li'.
      const fetchedCount = content.querySelector('.collection-banner__count');
      const currentCount = document.querySelector('.collection-banner__count');
      if (fetchedCount && currentCount) currentCount.textContent = fetchedCount.textContent;

      if (typeof initLazyImages === 'function') initLazyImages();
      if (customPagination && customPagination.reload) customPagination.reload();
      if (updateUrl) FacetFilters.updateURL(searchParams);

      if (this.results.getBoundingClientRect().top < 0) {
        let headerHeight = 0;
        if (document.querySelector('store-header[data-is-sticky="true"]')) {
          headerHeight = Number.parseInt(
            getComputedStyle(this.parentElement || document.body)
              .getPropertyValue('--header-height')
              .replace('px', ''),
            10
          ) || 0;
        }
        window.scrollTo({
          top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
          behavior: 'smooth'
        });
      }
    }

    /**
     * Updates the filters with the fetched data.
     * @param {string} html - HTML of the fetched document.
     * @param {object} evt - Event object.
     */
    updateFilters(html, evt) {
      document.querySelectorAll('.filter').forEach((filter) => {
        const { index } = filter.dataset;
        const fetchedFilter = html.querySelector(`.filter[data-index="${index}"]`);

        if (filter.dataset.type !== 'sort') {
          if (filter.dataset.type === 'price_range') {
            FacetFilters.updateFilter(filter, fetchedFilter, false);

            if (!evt || evt.target.tagName !== 'INPUT') {
              filter.querySelectorAll('input').forEach((input) => {
                input.value = html.getElementById(input.id).value;
              });

              // Update the price range track visual
              const priceRange = filter.querySelector('price-range');
              if (priceRange && priceRange.updateTrack) {
                priceRange.updateTrack();
              }
            }
          } else if (evt && evt.target.tagName === 'INPUT') {
            const changedFilter = evt.target.closest('.filter');

            if (changedFilter && changedFilter.dataset) {
              FacetFilters.updateFilter(
                filter,
                fetchedFilter,
                filter.dataset.index !== changedFilter.dataset.index
              );
            }
          } else {
            FacetFilters.updateFilter(filter, fetchedFilter, true);
          }
        }
      });

      // Update active filters.
      this.updateActiveFilters(html);

      // Update '[x] results' button (mobile only).
      const footerEl = html.querySelector('.facets__footer');
      this.footer.innerHTML = footerEl.innerHTML;
    }

    /**
     * Updates a filter.
     * @param {Element} filter - Filter element.
     * @param {Element} fetchedFilter - Fetched filter element.
     * @param {boolean} updateAll - Update all filter markup or just toggle/header.
     */
    static updateFilter(filter, fetchedFilter, updateAll) {
      if (fetchedFilter) {
        filter.hidden = false;
        if (updateAll) {
          filter.innerHTML = fetchedFilter.innerHTML;
        } else {
          // Update toggle and header only.
          const currentToggle = filter.querySelector('.filter__toggle');
          const fetchedToggle = fetchedFilter.querySelector('.filter__toggle');
          if (currentToggle && fetchedToggle) {
            filter.replaceChild(fetchedToggle, currentToggle);
          }

          const currentHeader = filter.querySelector('.filter__header');
          const fetchedHeader = fetchedFilter.querySelector('.filter__header');
          if (currentHeader && fetchedHeader) {
            currentHeader.innerHTML = fetchedHeader.innerHTML;
          } else if (!currentHeader && fetchedHeader) {
            // If current filter doesn't have header but fetched does, we need to add it
            const divButtonMore = filter.querySelector('.div-button-more');
            const disclosureContent = filter.querySelector('.disclosure__content');
            if (divButtonMore) {
              divButtonMore.innerHTML = fetchedFilter.querySelector('.div-button-more').innerHTML;
            } else if (disclosureContent) {
              // Create the div-button-more from fetched filter
              const fetchedDivButtonMore = fetchedFilter.querySelector('.div-button-more');
              if (fetchedDivButtonMore) {
                disclosureContent.appendChild(fetchedDivButtonMore.cloneNode(true));
              }
            }
          }
        }
      } else {
        filter.hidden = true;
      }
    }

    /**
     * Updates the active filters.
     * @param {string} html - HTML of the fetched page.
     */
    updateActiveFilters(html) {
      const activeFiltersList = html.querySelector('.active-filters');
      const activeFiltersHeader = html.querySelector('.active-filters-header');

      this.activeFiltersList.innerHTML = activeFiltersList.innerHTML;
      this.activeFiltersHeader.innerHTML = activeFiltersHeader.innerHTML;
      const hasActiveFilters = this.activeFiltersList.querySelector('.active-filter');
      this.activeFilters.hidden = !hasActiveFilters;
      
      // Show/hide clear all button at bottom (desktop)
      const clearAllBottom = this.querySelector('.facets__clear-all-bottom');
      if (clearAllBottom) {
        clearAllBottom.style.display = hasActiveFilters ? 'block' : 'none';
      }
      
      // Show/hide clear all button on mobile
      const clearAllMobile = this.querySelector('.js-clear-all-mobile');
      if (clearAllMobile) {
        if (hasActiveFilters) {
          clearAllMobile.classList.remove('is-hidden');
        } else {
          clearAllMobile.classList.add('is-hidden');
        }
      }
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      // Decisione Cisalfa 15/09 (Unguess 451528): il tasto indietro deve
      // mantenere i filtri. Applicare filtri/ordinamento aggiorna la voce di
      // cronologia corrente invece di aggiungerne una: il back porta alla pagina
      // di provenienza e, tornando alla listing, i filtri sono ancora nell'URL.
      window.history.replaceState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
}

// Handle filter expand/collapse based on viewport
let lastViewportWidth = window.innerWidth;
let initialLoadDone = false;

function handleFilterExpandByViewport(forceReset = false) {
  const isMobile = window.innerWidth < 1024;
  const filterDetails = document.querySelectorAll('details[data-expand-desktop][data-expand-mobile]');

  // Only reset filters on initial load or when crossing the breakpoint
  if (!forceReset && initialLoadDone) {
    return;
  }

  filterDetails.forEach(detail => {
    const expandDesktop = detail.dataset.expandDesktop === 'true';
    const expandMobile = detail.dataset.expandMobile === 'true';

    if (isMobile) {
      detail.open = expandMobile;
    } else {
      detail.open = expandDesktop;
    }
  });

  initialLoadDone = true;
}

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  handleFilterExpandByViewport(true);
  lastViewportWidth = window.innerWidth;
});

// Run on resize only when crossing the 1024px breakpoint
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const currentWidth = window.innerWidth;
    const wasMobile = lastViewportWidth < 1024;
    const isMobile = currentWidth < 1024;

    // Only reset if we crossed the breakpoint
    if (wasMobile !== isMobile) {
      handleFilterExpandByViewport(true);
    }

    lastViewportWidth = currentWidth;
  }, 150);
});
